module.exports = __webpack_public_path__ + "img/goal.1e211ec3.svg";